import { connect } from 'react-redux';
import { requestSORefund, printMSORefundPDF } from '../../actions/sales_actions';
import MSOPaymentInfo from '../../components/Sales/MSOPaymentInfo';

const mapStateToProps = (state) => {
  return {
    refund: state.salesOrders.refund,
  };
};

const MSOPaymentInfoContainer = connect(mapStateToProps, { requestSORefund, printMSORefundPDF })(MSOPaymentInfo);

export default MSOPaymentInfoContainer;



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/MSOPaymentInfo.jsx